<div class="radial-button-cell" [class.edit-mode]="isEditMode">
  <label *ngIf="labelText" class="radial-label">{{ labelText }}</label>
  
  <div class="radial-options-container" 
       [class.horizontal-layout]="layoutDirection === 'horizontal'"
       [class.vertical-layout]="layoutDirection === 'vertical'"
       [class.grid-layout]="useGridLayout"
       [style.grid-template-columns]="useGridLayout ? 'repeat(' + gridColumns + ', 1fr)' : null">
    
    <div *ngIf="isLoadingOptions" class="loading-message">
      Loading options...
    </div>
    
    <div *ngFor="let option of radialOptions" 
         class="radial-option"
         [class.selected]="selectedValue === option.value">
      <input type="radio" 
             [id]="cell.id + '_' + option.value"
             [name]="cell.id"
             [value]="option.value"
             [checked]="selectedValue === option.value"
             (change)="onRadialChange(option.value)"
             [disabled]="isEditMode || isLoadingOptions">
      <label [for]="cell.id + '_' + option.value" 
             class="radial-option-label"
             [title]="option.label">
        {{ option.label }}
      </label>
    </div>
    
    <div *ngIf="!isLoadingOptions && radialOptions.length === 0" class="no-options-message">
      {{ placeholder || 'No options available' }}
    </div>
  </div>
</div>